import _this from '../../../src/main.js'
export default {
  state: {
    uuid: '',
    languageI18n: '', // 中或英
    isElJsVisible: true, // element Js 生成部分。切换时的控制
    artTypeList: [],
    writeInstList: [],
    investMarketList: [],
    incomeStageList: [],
    artistStageList: [],
    artworkLabelList:[],
    literatuRecordTypereList: [],
    currentList: [],
    archivedTypeList: [],
    artContractTypeList: [],
    allUserList: [],
    allOrganizationList: [],
    allEntList: [],
    allVendorsList: [],
    allPaymentList: [],
    allCountryList: [],
    countryList: [],
    allTransportFeeCurrencyList: [],
    allTransportTypeList: [],
    allInsureFeeCalcTypeList: [],
    incomeFundSubjectList: [],
    packagingTypeList: [],
    allExPurposeList: [],
    allCountrysList: [],
    allStoreList: [],
    allReplicaTypeList: [],
    finFeeAttributionAndSubject: [],
    alluserPermission: [],
    allPaymentPropertyList: [],
    allCompanyBudgetList: [],
    allTypeOfCompanyList: [],
    eventTypeList: [],
    artPicTypeList: [],
    hidden_sm_and_down: document.body.clientWidth <= 991
  },
  actions: {// 在action中可以进行异步操作，外部用dispatch()调用
    /**
     * 获取当前屏幕
     * */
    set_hidden_sm_and_down ({commit, state}, param) {
      commit('set_hidden_sm_and_down', param)
    },
    /**
     * 获取费用归属
     * */
    getFinFeeAttributionAndSubject (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/data_dictionary/get_data_dictionary', { dictCode: 'FIN_FEE_ATTRIBUTION' }, 'GET').then((res) => {
          if (res.code === 0) {
            state.commit('SET_FIN_FEE_ATTRIBUTION_AND_SUBJECT_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 获取包装方式
     * */
    getPackagingTypeList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/data_dictionary/get_data_dictionary', { dictCode: 'PACKAGING_TYPE' }, 'GET').then((res) => {
          if (res.code === 0) {
            state.commit('SET_PACKAGING_TYPE_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
    /**
     * 获取家族基金收益科目
     * */
    getIncomeFundSubjectList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/data_dictionary/get_dictionary_tree_by_code', { dictCode: 'INCOME_FUND_SUBJECT' }, 'GET').then((res) => {
          if (res.code === 0) {
            state.commit('SET_INCOME_FUND_SUBJECT_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
    * 获取创作媒介
    * */
    getArtTypeList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/mdm_tag/get_mdm_tag_by_parent_tag', { parentTagId: 'ART_CREATE_MYT' }, 'GET').then((res) => {
          if (res.code === 0) {
            state.commit('SET_ART_TYPE_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 获取创作分期
     * */
    getWriteInstList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/mdm_tag/get_mdm_tag_by_parent_tag', { parentTagId: 'ART_PERIOD' }, 'GET').then((res) => {
          if (res.code === 0) {
            state.commit('SET_WRITE_INST_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 获取投资市场
     * */
    getInvestMarketList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/mdm_tag/get_mdm_tag_by_parent_tag', { parentTagId: 'ART_INVEST_MARKET' }, 'GET').then((res) => {
          if (res.code === 0) {
            state.commit('SET_INVEST_MARKET_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 获取收益阶段
     * */
    getIncomeStageList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/mdm_tag/get_mdm_tag_by_parent_tag', { parentTagId: 'ART_INCOME_STAGE' }, 'GET').then((res) => {
          if (res.code === 0) {
            state.commit('SET_INCOME_STAGE_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 获取艺术家发展阶段
     * */
    getArtistStageList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/mdm_tag/get_mdm_tag_by_parent_tag', { parentTagId: 'T00001638' }, 'GET').then((res) => {
          if (res.code === 0) {
            state.commit('SET_ARTIST_STAGE_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 获取艺术品标签
     * */
    getArtworkLabelList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/mdm_tag/get_mdm_tag_by_parent_tag', { parentTagId: 'T00001644' }, 'GET').then((res) => {
          if (res.code === 0) {
            state.commit('SET_ARTWORK_LABEL_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 获取事件类型
     * */
    getEventTypeList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/data_dictionary/get_data_dictionary', { dictCode: 'EVENT_TYPE' }, 'GET').then((res) => {
          if (res.code === 0) {
            state.commit('SET_EVENT_TYPE_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 获取记录类型
     * */
    getLiteratuRecordTypereList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/data_dictionary/get_data_dictionary', { dictCode: 'LITERATU_RECORD_TYPERE' }, 'GET').then((res) => {
          if (res.code === 0) {
            state.commit('SET_LITERATU_RECORD_TYPERE_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 获取图片类型
     * */
    getArtPicTypeList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/data_dictionary/get_data_dictionary', { dictCode: 'ART_PIC_TYPE' }, 'GET').then((res) => {
          if (res.code === 0) {
            state.commit('SET_ART_PIC_TYPE_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 币种
     * */
    getCurrentList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/data_dictionary/get_data_dictionary', { dictCode: 'CURRENCY' }, 'GET').then((res) => {
          if (res.code === 0) {
            state.commit('SET_CURRENCY_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 归档类型
     * */
    getArchivedTypeList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/data_dictionary/get_data_dictionary', { dictCode: 'ARCHIVED_TYPE' }, 'GET').then((res) => {
          if (res.code === 0) {
            state.commit('SET_ARCHIVED_TYPE_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 合同类型
     * */
    getArtContractTypeList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/data_dictionary/get_data_dictionary', { dictCode: 'ART_CONTRACT_TYPE' }, 'GET').then((res) => {
          if (res.code === 0) {
            state.commit('SET_ART_CONTRACT_TYPE_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 获取用户列表(JMS同步)
     * */
    getAllUserList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/art/getAllUser', {}, 'POST').then((res) => {
          if (res.code === 0) {
            state.commit('SET_ALL_USER_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 获取所有部门数据(JMS同步)
     * */
    getAllOrganizationList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/art/getAllOrganization', {}, 'POST').then((res) => {
          if (res.code === 0) {
            state.commit('SET_ALL_ORGANIZATION_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 获取所有实体公司(JMS同步)
     * */
    getAllEntList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/art/getAllEnt', {}, 'POST').then((res) => {
          if (res.code === 0) {
            state.commit('SET_ALL_ENT_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 获取所有第三方(JMS同步)
     * */
    getAllVendorsList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/art/getAllVendors', {}, 'POST').then((res) => {
          if (res.code === 0) {
            state.commit('SET_ALL_VENDORS_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 获取所有支付方式(JMS同步)
     * */
    getAllPaymentList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/data_dictionary/get_data_dictionary', { dictCode: 'TRANSPORT_PAY_TYPE' }, 'GET').then((res) => {
          if (res.code === 0) {
            state.commit('SET_ALL_PAYMENT_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 获取所有到达地-国家(JMS同步)
    * */
    getAllCountryList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/data_dictionary/get_data_dictionary', { dictCode: 'COUNTRY' }, 'GET').then((res) => {
          if (res.code === 0) {
            state.commit('SET_ALL_COUNTRY_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 获取国家坐标集合
     * */
    getCountryList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/country/getCountryList', {}, 'GET').then((res) => {
          if (res.code === 0) {
            state.commit('SET_COUNTRY_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 获取所有运输方式(JMS同步)
    * */
    getAllTransportTypeList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/data_dictionary/get_data_dictionary', { dictCode: 'TRANSPORT_TYPE' }, 'GET').then((res) => {
          if (res.code === 0) {
            state.commit('SET_ALL_TRANSPORT_TYPE_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 获取所有保费计算方式(JMS同步)
    * */
    getAllInsureFeeCalcTypeList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/data_dictionary/get_data_dictionary', { dictCode: 'INSURE_FEE_CALC_TYPE' }, 'GET').then((res) => {
          if (res.code === 0) {
            state.commit('SET_ALL_INSURE_FEE_CALC_TYPE_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 获取所有出库用途(JMS同步)
    * */
    getAllExPurposeList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/data_dictionary/get_data_dictionary', { dictCode: 'EX_PURPOSE' }, 'GET').then((res) => {
          if (res.code === 0) {
            state.commit('SET_ALL_EX_PURPOSE_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 获取所有国家
    * */
    getAllCountrysList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/country/getCountryList', {}, 'GET').then((res) => {
          if (res.code === 0) {
            state.commit('SET_ALL_COUNTRYS_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
    * 获取所有库房
   * */
    getAllStoreList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/room/getRoomList', {}, 'GET').then((res) => {
          if (res.code === 0) {
            state.commit('SET_ALL_STORE_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 复制方式
    * */
    getAllReplicaTypeList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/data_dictionary/get_data_dictionary', { dictCode: 'REPLICA_TYPE' }, 'GET').then((res) => {
          if (res.code === 0) {
            state.commit('SET_ALL_REPLICA_TYPE_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 付款性质
    * */
    getallPaymentPropertyList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/data_dictionary/get_data_dictionary', { dictCode: 'PAYMENT_PROPERTY' }, 'GET').then((res) => {
          if (res.code === 0) {
            state.commit('SET_ALL_PAYMENT_PROPERTY_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 预算科目
    * */
    getallCompanyBudgetList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/data_dictionary/get_data_dictionary', { dictCode: 'COMPANY_BUDGET' }, 'GET').then((res) => {
          if (res.code === 0) {
            state.commit('SET_ALL_COMPANY_BUDGET_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 合同类型（拍摄/复制）
    * */
     getallTypeOfCompanytList (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/data_dictionary/get_child_dictionary_tree_by_code', { dictCode: 'AGREEMENT_CONTRACT_TYPE', level: 1 }, 'GET').then((res) => {
          if (res.code === 0) {
            state.commit('SET_ALL_TYPE_OF_COMPANY_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
     * 运营类型（运营中作品）
    * */
    getAllEventTypelist (state) {
      return new Promise((resolve, reject) => {
        _this.reqServiceOf0('/data_dictionary/get_data_dictionary', { dictCode: 'EVENT_TYPE'}, 'GET').then((res) => {
          if (res.code === 0) {
            state.commit('SET_ALL_TYPE_OF_EVENT_TYPE_LIST', res.data)
          }
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

  },
  getters: {// 获取state里面的数据
    change_hidden_sm_and_down (state) {
      return state.hidden_sm_and_down
    },
  },
  mutations: {// 不要在mutations里面进行异步操作，外部用commit()调用
    SET_LANG_I18n (state, data) {
      state.languageI18n = data
    },
    SET_IS_EL_JS_VISIBLE (state, data) {
      state.isElJsVisible = data
    },
    set_hidden_sm_and_down: (state, data) => {
      state.hidden_sm_and_down = data
    },
    SET_ART_TYPE_LIST: (state, data) => {
      state.artTypeList = data
    },
    SET_WRITE_INST_LIST: (state, data) => {
      state.writeInstList = data
    },
    SET_INVEST_MARKET_LIST: (state, data) => {
      state.investMarketList = data
    },
    SET_INCOME_STAGE_LIST: (state, data) => {
      state.incomeStageList = data
    },
    SET_ARTIST_STAGE_LIST: (state, data) => {
      state.artistStageList = data
    },
    SET_ARTWORK_LABEL_LIST: (state, data) => {
      state.artworkLabelList = data
    },
    SET_LITERATU_RECORD_TYPERE_LIST: (state, data) => {
      state.literatuRecordTypereList = data
    },
    SET_EVENT_TYPE_LIST: (state, data) => {
      state.eventTypeList = data
    },
    SET_CURRENCY_LIST: (state, data) => {
      state.currentList = data
    },
    SET_ARCHIVED_TYPE_LIST: (state, data) => {
      state.archivedTypeList = data
    },
    SET_ART_CONTRACT_TYPE_LIST: (state, data) => {
      state.artContractTypeList = data
    },
    SET_ALL_USER_LIST: (state, data) => {
      state.allUserList = data
    },
    SET_ALL_ORGANIZATION_LIST: (state, data) => {
      state.allOrganizationList = data
    },
    SET_ALL_ENT_LIST: (state, data) => {
      state.allEntList = data
    },
    SET_ALL_VENDORS_LIST: (state, data) => {
      state.allVendorsList = data
    },
    SET_ALL_PAYMENT_LIST: (state, data) => {
      state.allPaymentList = data
    },
    SET_ALL_COUNTRY_LIST: (state, data) => {
      state.allCountryList = data
    },
    SET_COUNTRY_LIST: (state, data) => {
      state.countryList = data
    },
    SET_ALL_TRANSPORT_TYPE_LIST: (state, data) => {
      state.allTransportTypeList = data
    },
    SET_ALL_INSURE_FEE_CALC_TYPE_LIST: (state, data) => {
      state.allInsureFeeCalcTypeList = data
    },
    SET_ALL_EX_PURPOSE_LIST: (state, data) => {
      state.allExPurposeList = data
    },
    SET_INCOME_FUND_SUBJECT_LIST: (state, data) => {
      state.incomeFundSubjectList = data
    },
    SET_PACKAGING_TYPE_LIST: (state, data) => {
      state.packagingTypeList = data
    },
    SET_FIN_FEE_ATTRIBUTION_AND_SUBJECT_LIST: (state, data) => {
      state.finFeeAttributionAndSubject = data
    },
    SET_ALL_COUNTRYS_LIST: (state, data) => {
      state.allCountrysList = data
    },
    SET_ALL_STORE_LIST: (state, data) => {
      state.allStoreList = data
    },
    SET_ALL_REPLICA_TYPE_LIST: (state, data) => {
      state.allReplicaTypeList = data
    },
    SET_ALL_PAYMENT_PROPERTY_LIST: (state, data) => {
      state.allPaymentPropertyList = data
    },
    SET_ALL_COMPANY_BUDGET_LIST: (state, data) => {
      state.allCompanyBudgetList = data
    },
    SET_ALL_TYPE_OF_COMPANY_LIST: (state, data) => {
      state.allTypeOfCompanyList = data
    },
    SET_ALL_TYPE_OF_EVENT_TYPE_LIST: (state, data) => {
      state.eventTypeList = data
    },
    SET_ART_PIC_TYPE_LIST: (state, data) => {
      state.artPicTypeList = data
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/global/index.js